// /vs/zynthoro-vs-odoo — audit D1.4 / D5.3.

import ComparisonPage from "./ComparisonPage";

const DATA = {
  slug: "odoo",
  competitor: "Odoo",
  title: "Zynthoro vs Odoo — Honest comparison | Zynthoro",
  description:
    "Side-by-side comparison of Zynthoro and Odoo: pricing model, modules, AI assistants and migration.",
  heroHeadline: "Zynthoro vs Odoo.",
  heroIntro:
    "Odoo is a long-established, modular all-in-one platform for growing businesses, with per-user pricing. Zynthoro is an AI-native all-in-one platform with fixed-tier pricing and four built-in AI specialists. Here's how they compare on the points buyers tell us matter most.",
  pricing: {
    zynthoro: {
      price: "From €79 one-time, or from €499/month",
      note: "Published, fixed tiers. Lifetime Kickstart from €79 (one payment). Starter subscription from €499/month. See the pricing page for the full ladder.",
    },
    competitor: {
      price: "Per-user, per-month",
      note: "Odoo lists per-user pricing on their website, usually tied to an app selection, and the final figure depends on edition and apps chosen. Check odoo.com for current rates in your region.",
    },
    disclaimer:
      "Vendor pricing changes over time. Numbers above are directional; confirm the latest on each vendor's own site.",
  },
  matrix: [
    { feature: "Pricing model", zynthoro: "Fixed tiers (€79 lifetime, €499+/mo subscriptions)", competitor: "Per-user per-month, varies by edition and apps" },
    { feature: "Four built-in AI specialists", zynthoro: true, competitor: "AI features vary by app and edition" },
    { feature: "Voice input in product workflows", zynthoro: true, competitor: "Not a core marketed feature" },
    { feature: "EU data residency option", zynthoro: true, competitor: "Available depending on hosting choice" },
    { feature: "Lifetime (one-time) entry option", zynthoro: "Kickstart 1-3 (€79-€199)", competitor: "Not offered" },
    { feature: "Full ERP (all 12 modules)", zynthoro: "Enterprise plan only", competitor: "Via Odoo apps catalog" },
    { feature: "Public, no-call pricing page", zynthoro: true, competitor: true },
  ],
  migration:
    "Migration options depend on your current tools and data. We'll review the available route with you during the demo call.",
  faq: [
    {
      q: "Is Zynthoro cheaper than Odoo?",
      a: "It depends on your edition, user count and selected apps. Odoo prices per user and per app; Zynthoro prices in fixed tiers. For an apples-to-apples number, compare your current Odoo invoice against the Zynthoro tier that matches your workflow needs.",
    },
    {
      q: "Can I migrate from Odoo?",
      a: "Migration options depend on your current tools and data. We'll review the available route with you during the demo call.",
    },
    {
      q: "Does Zynthoro replace Odoo for accounting?",
      a: "Zynthoro covers invoicing, VAT and finance reporting for standard EU flows. For deep manufacturing MRP or heavy non-EU localisation, Odoo's app catalogue may still be the stronger fit. We'll be honest with you on the demo call.",
    },
    {
      q: "What about contract overlap?",
      a: "You can run Zynthoro alongside your existing Odoo workspace while you evaluate — nothing in the setup forces an immediate cutover.",
    },
  ],
};

export default function ZynthoroVsOdoo() {
  return <ComparisonPage data={DATA} />;
}
